import { rootStyle } from "../../styles/index.mjs";
import { TypeListItem as Item } from "../TypeListItem/index.mjs";
import styled from "../../styled-components.mjs";
export var ListItem = styled(Item).attrs({
  variant: 'bodyMedium',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "ListItem",
  componentId: "sc-qa47qy-0"
})(["", ";overflow-wrap:break-word;"], rootStyle());